import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { AppThemeType } from "src/types/apps";

import { apiClient } from "../../config/apiClient";
import { API } from "../../config/apiConfig";
import { GetLinkThemePayload } from "./NetTypes";

async function getLinkThemesRequest({ id, type }: GetLinkThemePayload) {
	return await apiClient
		.get(API.QUERY.LINK.THEME, { params: { id, type: type.toUpperCase() } })
		.then((res) => res.data);
}

export function useGetLinkThemesRequest(values: GetLinkThemePayload) {
	return useQuery<AppThemeType, AxiosError>({
		queryKey: ["link", "theme", values.id],
		queryFn: () => getLinkThemesRequest(values)
	});
}
